import { FC } from 'react';

import AuthenticationLayout from '@/components/layout/AuthenticationLayout.tsx';
import ForgotPasswordForm from '@/components/layout/forgotPasswordPage/ForgotPasswordForm.tsx';

const ForgotPassword: FC = () => {
  return (
    <AuthenticationLayout>
      <ForgotPasswordForm />
    </AuthenticationLayout>
  );
};

export default ForgotPassword;
